__webpack_require__.p = "https://static.yandexcom.net/s3/newbiz-logistics-frontend/yandexcom/v2/tariffs/";